import React from "react"
import Styles from "./errorList.less"
import {connect} from "react-redux"
import errorImg from "../../../../../static/pic/error.svg"
import {UseFileInfo, UseModel} from "../../../../../function/hooks/useDataFromRedux"
import {VIEWTYPE} from "../../../../util/utilData"
import {ReducerState} from "../../../../../reducer/interface/baseInterface"
import {ComparisonStatus} from "../../../../../reducer/interface/controlInterface"

interface ErrorListProps {
    viewType: string
    comparisonStatus: ComparisonStatus
}

const ErrorList: React.FunctionComponent<ErrorListProps> = (props) => {
    // const model = UseModel()
    // const [baseInfo, compareInfo] = [UseFileInfo().useDisplayBase(), UseFileInfo().useDisplayCompare()]
    // const startComparison = () => {
    //     model.invokeAsync("startComparison", {
    //         baseFile: {
    //             fileName: baseInfo.name,
    //             url: baseInfo.url,
    //         },
    //         compareFile: {
    //             fileName: compareInfo.name,
    //             url: compareInfo.url,
    //         },
    //     })
    // }
    return (
        <div className={Styles.errorList}>
            <img src={errorImg} alt={""} />
            <div className={Styles.errorInfoBox}>
                <span className={Styles.mainError}>
                    {props.comparisonStatus.errorMsg && props.comparisonStatus.errorMsg.progress}
                </span>
                <span className={Styles.mainError}>
                    taskId:{props.comparisonStatus.errorMsg && props.comparisonStatus.errorMsg.taskId}
                </span>
                <span className={Styles.mainError}>
                    traceId:{props.comparisonStatus.errorMsg && props.comparisonStatus.errorMsg.traceId}
                </span>
            </div>
        </div>
    )
}
export default connect((state: ReducerState) => {
    return {
        viewType: state.global.viewType,
        comparisonStatus: state.control.comparisonStatus,
    }
})(ErrorList)
